import type { ClientErrorCode, MiddlewareErrorCode } from './constants.js';

export type Severity = 'info' | 'warn' | 'error' | 'debug';

export abstract class BaseError<TError extends ClientErrorCode | MiddlewareErrorCode> extends Error {
  /* Replicated backend error code that is handled internally */
  private readonly _code?: string;

  /* Custom client error code to separate different kinds of exceptions */
  private readonly _clientCode: TError;

  /* Extra data logged to kibana for tracing, can be anything */
  private readonly _extraData?: object;

  constructor({
    clientCode,
    code,
    extraData,
    message,
  }: {
    clientCode: TError;
    code?: string;
    extraData?: object;
    message?: string;
  }) {
    super(message);
    this._code = code;
    this._clientCode = clientCode;
    this._extraData = extraData;
    this.name = 'BaseError';
  }

  get handledError(): boolean {
    return false;
  }

  get severity(): Severity {
    return 'info';
  }

  get code(): string | undefined {
    return this._code;
  }

  get clientCode(): TError {
    return this._clientCode;
  }

  toJSON(): {
    clientCode: TError;
    code?: string;
    message: string;
    extra?: object;
  } {
    return {
      clientCode: this._clientCode,
      code: this._code,
      message: this.message,
      extra: this._extraData,
    };
  }

  override toString(): string {
    return JSON.stringify(this.toJSON());
  }
}
